import React from 'react';
import { FaUsers } from 'react-icons/fa';
import styled from 'styled-components';

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const IconButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: #2563eb;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #f3f4f6; }
`;

const Badge = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
`;

const CountLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  height: 24px;
  border-radius: 12px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 700;
  color: ${({ $active }) => ($active ? '#1e3a5f' : '#64748b')};
  background: ${({ $active }) => ($active ? '#eaf1ff' : '#f1f5f9')};
  border: 1px solid ${({ $active }) => ($active ? '#bfdbfe' : '#e2e8f0')};
`;

export default function TeamworkButton({ count = 0, overdue = false, onClick }) {
  return (
    <Wrap>
      <IconButton onClick={onClick} aria-label="Teamwork" style={overdue ? { color: '#ef4444' } : undefined}>
        <FaUsers size={22} />
        {count > 0 && <Badge>{count}</Badge>}
      </IconButton>
      <CountLabel $active={count > 0} title="Unread teamwork messages">
        Unread {count}
      </CountLabel>
    </Wrap>
  );
}
